// extracted by mini-css-extract-plugin
export default {"modal":"styles_modal__vDEZv","btn-ok-save":"styles_btn-ok-save__bsfzS","btn-ok-delete":"styles_btn-ok-delete__2VmPr"};